<template>
	<CTabs
		:active-tab.sync="input"
		add-nav-wrapper-classes="custom-wrapper-nav-tabs sticky-with-body-scroll-left"
	>
		<slot></slot>
	</CTabs>
</template>

<script>
export default {
	name: 'BaseTabBar',

	props: {
		value: {
			type: Number,
			default: 0,
		},
	},

	data() {
		return {
			input: 0,
		};
	},

	watch: {
		input() {
			this.$emit('input', this.input);
		},
	},

	mounted() {
		this.input = this.value;
	},
};
</script>

<style lang="scss" scoped>
::v-deep .custom-wrapper-nav-tabs {
	margin: rem(-32) rem(-28) rem(32) rem(-28);
	padding-top: rem(32);
	background-color: $color-wild-sand;

	.nav-tabs {
		border-color: $color-gray-300;
	}

	.nav-item {
		&:first-of-type {
			margin-left: rem(24);
		}

		.nav-link {
			&.active {
				background-color: $color-white;
				color: $color-black-90;
			}

			background-color: $color-gallery;
			border: solid 1px $color-gray-300;
			border-bottom: transparent;
			font-weight: $font-weight-bold;
			color: $color-black-45;
		}
	}
}
</style>